<template>
  <div class="youtubeModal" @click="close" :style="{ display: (openDialog ? 'flex' : 'none') }">
    <div @click.stop class="youtubeDialogBox" :class="{ openComplete: openComplete }">
      <div class= "youtubeButtonArea">
        <img class= "youtubeButtonCansel" @click="close" src="/img/close.png" alt="" />
      </div>
      <div class="main">
        <iframe v-if="isOpen" width="100%" height="100%" :src="url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: [
    'isOpen',
    'url'
  ],
  data () {
    return {
      dialogOpen: false,
      openComplete: false
    }
  },
  computed: {
    openDialog: {
      get () {
        return this.isOpen
      },
      set (value) {
        this.$emit('update:isOpen', value)
      }
    }
  },
  methods: {
    close () {
      this.$ga.event('YoutubeDialog', 'cancel', `${this.url}`, null)
      this.openComplete = false
      setTimeout(() => {
        this.openDialog = false
      }, 500)
    },
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        setTimeout(() => {
          this.openComplete = true
        }, 100)
        this.$ga.event('YoutubeDialog', 'open', `${this.url}`, null)
      } else {
        this.openComplete = false
      }
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped>
.youtubeModal {
  font-family: "Noto Sans JP";
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow-y: auto;
  display: none;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99999;
}
.youtubeDialogBox {
  margin: 0px;
  padding: 0px;
  font-size: 1rem;
  opacity: 0;
  width: 0px;
  height: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: black;
  transition: all 0.5s;
  z-index: 10000;
}
.youtubeDialogBox.openComplete {
  width: 90%;
  height: 70%;
  opacity: 1;
}

.youtubeDialogBox span{
  font-size: 16px;
    font-weight: 700;
    margin-bottom: 10px;
    display: inline-block;
}
.main {
  width: 100%;
  height: 100%;
}
.youtubeButtonArea{
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  background-color: black;
}

.youtubeButtonCansel{
  width: 32px;
  height: 32px;
  margin-bottom: 16px;
  cursor: pointer;
}
.youtubeButtonCansel:hover {
	opacity: 0.5;
	transition: opacity .4s ease-in-out;
	-moz-transition: opacity .4s ease-in-out;
	-webkit-transition: opacity .4s ease-in-out;
}


</style>
